import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("foreignObject", {
        width: "15.822",
        height: "11.207",
        x: "1.255",
        y: "3.642"
      }, [
        _createElementVNode("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: {"backdrop-filter":"blur(.83px)","clip-path":"url(#b)","height":"100%","width":"100%"}
        })
      ]),
      _createElementVNode("path", {
        stroke: "#A7A7B1",
        "stroke-width": "1.172",
        d: "M6.912 5.883h7.51c.206 0 .324 0 .408.008h.002v.005a5 5 0 0 1-.078.399l-1.209 5.595a7 7 0 0 1-.106.453.4.4 0 0 1-.047.12.35.35 0 0 1-.146.119.4.4 0 0 1-.128.02 7 7 0 0 1-.462.01h-8.47q.007-.029.015-.053c.129-.427.207-.682.474-1.555.447-1.458 1.013-3.322 1.362-4.473.13-.43.158-.486.183-.517a.35.35 0 0 1 .143-.106c.037-.015.098-.025.549-.025Z",
        "data-figma-bg-blur-radius": "1.654",
        style: {"stroke":"color(display-p3 .6543 .6543 .6951)","stroke-opacity":"1"}
      }),
      _createElementVNode("path", {
        fill: "#6E6E7D",
        d: "M7.19 2.702a.83.83 0 0 1 .387.112c.083.05.155.12.299.258l.085.081c.144.14.216.209.3.258a.8.8 0 0 0 .228.093 1 1 0 0 0 .158.02l.238.002h3.325c.534 0 .8 0 1.004.106a.94.94 0 0 1 .4.4c.076.144.096.323.102.61H8.21a2 2 0 0 1-.545-.221c-.23-.136-.414-.323-.519-.424l-.084-.081-.046-.045h-2.49l-.047.043-.302.284c-.242.227-.539.38-.857.452v5.654l-.103.339c-.292.946-.377 1.224-.518 1.687-.076.25-.124.426-.174.554a1.2 1.2 0 0 1-.245-.317c-.132-.254-.132-.587-.132-1.255V4.292c0-.422.343-.764.765-.765a.7.7 0 0 0 .361-.104l.101-.078.304-.284c.143-.135.215-.203.298-.25q.105-.06.224-.09c.093-.021.191-.02.388-.02h2.362z",
        style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1"}
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", {
        id: "b",
        transform: "translate(-1.255 -3.642)"
      }, [
        _createElementVNode("path", { d: "M6.912 5.883h7.51c.206 0 .324 0 .408.008h.002v.005a5 5 0 0 1-.078.399l-1.209 5.595a7 7 0 0 1-.106.453.4.4 0 0 1-.047.12.35.35 0 0 1-.146.119.4.4 0 0 1-.128.02 7 7 0 0 1-.462.01h-8.47q.007-.029.015-.053c.129-.427.207-.682.474-1.555.447-1.458 1.013-3.322 1.362-4.473.13-.43.158-.486.183-.517a.35.35 0 0 1 .143-.106c.037-.015.098-.025.549-.025" })
      ]),
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h15v15H0z",
          style: {"fill":"#fff","fill-opacity":"1"},
          transform: "translate(.5 .5)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }